
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25","cy":"25","r":"20","stroke":"#42B883","stroke-width":"4","fill":"none"}}),_c('circle',{attrs:{"cx":"25","cy":"25","r":"20","stroke":"#285891","stroke-width":"4","fill":"none","stroke-dasharray":"150","stroke-dashoffset":"70"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 25 25","to":"360 25 25","dur":"1.5s","repeatCount":"indefinite","keyTimes":"0; 0.5; 1","keySplines":"0.20 0 0.20 1; 0.20 0 0.20 1","calcMode":"spline"}})])])
          )
        }
      }
    